import * as React from 'react';

import { AlertContainer } from '../AlertContainer';
import { LoaderContainer } from '../LoaderContainer';
import { ButtonThemes } from 'shared/components/admin/ButtonThemes';
import { GrapesJsEditorContainer } from '../../../grapesJs/GrapesJsEditorContainer';

export const ProjectEditorPageContainer: React.FC = () => {
  return (
    <>
      <GrapesJsEditorContainer />
      <ButtonThemes />
      <AlertContainer />
      <LoaderContainer />
    </>
  );
};
